import { DEFAULT_LOCALE, type AppLocale } from "./config";

export type TranslationVars = Record<string, string | number>;
export type TranslationMessages = Record<string, unknown>;

export type TranslateFn = (key: string, fallback: string, vars?: TranslationVars) => string;

const resolveKey = (messages: TranslationMessages | null, key: string): string | undefined => {
  if (!messages) return undefined;
  let current: unknown = messages;
  for (const part of key.split(".")) {
    if (typeof current !== "object" || current === null) return undefined;
    current = (current as Record<string, unknown>)[part];
  }
  return typeof current === "string" ? current : undefined;
};

const interpolate = (value: string, vars?: TranslationVars): string => {
  if (!vars) return value;
  return value.replace(/\{(\w+)\}/g, (token, name: string) =>
    name in vars ? String(vars[name]) : token
  );
};

export const createTranslator =
  (locale: AppLocale, messages: TranslationMessages | null): TranslateFn =>
  (key, fallback, vars) => {
    if (locale === DEFAULT_LOCALE) return interpolate(fallback, vars);
    return interpolate(resolveKey(messages, key) ?? fallback, vars);
  };
